import React, { useState } from "react";
import { handlePercentage } from "../../../StudentData/handlers/percentageHandler";
import { X } from "lucide-react";

const percentageOptions = [0, 10, 25, 50, 75];

const ThresholdDropdown = ({ state, updateState, clearSelection }) => {
  const [open, setOpen] = useState(false);

  const handleSelect = (value) => {
    updateState(handlePercentage(state, value));
    setOpen(false);
  };

  return (
    <div className="relative w-full">
      {!open ? (
      <div
        className="justify-between rounded p-1.5 border border-[#DDDDDD] w-full h-full flex items-center cursor-pointer bg-white"
        onClick={() => setOpen(!open)}
      >
        <span className="flex flex-wrap items-center bg-blue-100 text-[#2763D4]  text-[14px] gap-2 px-2 py-1 rounded-full">
          {state.chosenPercentage !== ''
            ? `Over ${state.chosenPercentage}%`
            : "Any % above 0"
          }
          {state.chosenPercentage !== '' && (
            <button onClick={clearSelection} className="text-[#2763D4]">
              <X className="w-3 h-3" />
            </button>
          )}
        </span>
        <svg
          className="w-3 h-3 text-gray-600 mr-2"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 10 6"
          fill="currentColor"
        >
          <path d="M0 0l5 6 5-6H0z" />
        </svg>
      </div>
      ) : (
        <div className="bg-white border border-[#DDDDDD] rounded p-3">
          <div className="flex items-center justify-between">
            <span className="text-[14px]">Select Threshold</span>
            <svg
              onClick={(e) => {
                e.stopPropagation()
                setOpen(!open)
              }}
              className="w-3 h-3 text-gray-600 cursor-pointer"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 10 6"
              fill="currentColor"
            >
              <path d="M0 0l5 6 5-6H0z" />
            </svg>
          </div>
          <ul>
            {percentageOptions.map((option) => (
              <li
                key={option}
                className="flex items-center py-1 hover:bg-gray-100 cursor-pointer"
                onClick={() => handleSelect(option)}
              >
                <input
                  type="checkbox"
                  checked={state.chosenPercentage === option}
                  readOnly
                  className="mr-2 w-4 h-4 border border-1 rounded"
                  style={{
                    backgroundColor: state.chosenPercentage === option
                    ? "#2763D4"
                    : "transparent",
                  }}
                />
                <span className="text-[14px]">Over {option}%</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ThresholdDropdown;